<div class="guest-flow-participant-section-header">
  <h2>{{ title }}</h2>
  <button
    type="button"
    class="guest-flow-chat-button"
    [attr.aria-label]="chatLabel"
    [title]="chatLabel"
    (click)="chat.emit()">
    <i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i>
  </button>
</div>
